/*!

=========================================================
* ページャーコンポーネント
* CompornentName : Pagination
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Pagination, PaginationItem, PaginationLink
} from "reactstrap";


class MyPagination extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {

        const {active, last, url} = this.props;

        let items = [];
        //First Link
        items.push(
            <PaginationItem>
                <PaginationLink first href={url} />
            </PaginationItem>                
        );
        //Active
        if(active < 3){
            var start = 1;
        }else{
            var start = active - 2;
        }

        if(active === last){
          var end = active;
        }else{
            var end = start + 5;
            if(end > last ){
                end = last;
            }
        }
        //Prev Link
        let prev = start - 1;
        if(prev == 0){
            prev = 1;
        }
        items.push(
            <PaginationItem disabled={active == 1}>
                <PaginationLink previous href={url + "?page=" + prev} />
            </PaginationItem>                
        );


        for (var number = start; number <= end; number++) {
            items.push(
                <PaginationItem key={number} active={number == active}>
                    <PaginationLink href={url + "?page=" + number} >
                        {number}
                    </PaginationLink>
                </PaginationItem>,
            );
        }
        //Next
        let nextpage = number + 1;
        if(nextpage > last){
            nextpage = last;
        }

        items.push(
            <PaginationItem disabled={active == last}>
                <PaginationLink next href={url + "?page=" + nextpage} />
            </PaginationItem>                
        );
        items.push(
            <PaginationItem disabled={active == last}>
                <PaginationLink last href={url + "?page=" + last} />
            </PaginationItem>                
        );
      
      const paginationBasic = (
          <Pagination size="lg" aria-label="Page navigation">{items}</Pagination>
      );
      return paginationBasic;
    }
  }
  
  
  export default MyPagination;